import { Box } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

export type TransferIconName = 'ruler' | 'wallet' | 'location'

interface TransferIconProps {
  name: TransferIconName
  /** theme.spacing units */
  size?: number
  sx?: SxProps<Theme>
}

const ICON_SRC: Record<TransferIconName, string> = {
  ruler: '/static/icons/transfer/ic_ruler.svg',
  wallet: '/static/icons/transfer/ic_wallet.svg',
  location: '/static/icons/transfer/ic_location.svg',
}

/** Tinted line icon: a CSS mask over `currentColor`, so it follows the parent's text color. */
const TransferIcon = ({ name, size = 2.5, sx }: TransferIconProps) => {
  const src = ICON_SRC[name]
  return (
    <Box
      aria-hidden
      component="span"
      sx={[
        {
          display: 'inline-block',
          width: (theme) => theme.spacing(size),
          height: (theme) => theme.spacing(size),
          flexShrink: 0,
          bgcolor: 'currentColor',
          WebkitMaskImage: `url(${src})`,
          maskImage: `url(${src})`,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  )
}

export default TransferIcon
